import React from "react";
import userimg from "../../../assets/images/user.png";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

const UserCard = ({ analytics, user, isHome, loading }) => {

  return (
    <>
      <div className="row mt-2">
        <div className="col-md-12">
          <div className='datacardesign py-2'>
            <div className="row justify-content-between">
              <div className={isHome ? "col-md-5 " : "col-md-5 d-flex align-items-center "}>
                <div className='cardimages d-flex align-items-center'>
                  {isHome ? 
                  <img src={userimg} className="defaultimagesdash" alt="" /> 
                  :
                    user.avatar ? (
                      <div className="usercardesign m-0 ps-3" style={{ height: "auto" }}>
                      <div className='avatarimg ps-3'>
                        <img src={user.avatar} referrerPolicy={'no-referrer'} />
                      </div>
                      </div>
                    ) : (
                      <div className="usercardesign m-0 ps-3"  style={{ height: "auto" }}>
                      <div className='initials-placeholder abc'>
                        {user?.name?.split(' ').map(word => word[0]).slice(0, 2).join('')}
                      </div>
                      </div>
                    )
                  }
                  {isHome ?
                    <div className="welcometext ps-3">
                      <p> {loading ? ( <Skeleton width="20vw" /> ) : <> Welcome back ! </> }</p>
                      <h4>{loading ? ( <Skeleton width="25vw" /> ) : <>{user?.name} </> }</h4>
                    </div> 
                    :
                    <div className="welcometext notwelcome ps-3 pt-0 mt-0">
                      <h4>{user?.name}</h4>
                    </div>
                  }
                </div>
              </div>
              <div className="col-md-7">
        
                <div className="dashstatdata">
                  <div className="welcometext ">
                    <p>{loading ? <Skeleton width="5vw" /> : <> Total Training Duration </>} </p>
                    <h4>{loading ? <Skeleton width="5vw" /> :  analytics?.duration?.all?.sum?.humanReadable }</h4>
                  </div>
                  <div className="welcometext">
                    <p>{loading ? <Skeleton width="5vw" /> : <> Guided </>} </p>
                    <h4>{loading ? <Skeleton width="5vw" /> :  analytics?.duration?.guided?.sum?.humanReadable}</h4>

                  </div>
                  <div className="welcometext">
                    <p>{loading ? <Skeleton width="5vw" /> : <> Unguided </>} </p>
                    <h4>{loading ? <Skeleton width="5vw" /> : analytics?.duration?.unguided?.sum?.humanReadable}</h4>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserCard;
